import { RootState } from 'duck/store'

import { DASHBOARD_STORE_ID } from './types'

export const getDashboardState = (state: RootState) => state.scenes[DASHBOARD_STORE_ID]
